<template align="center">
    <v-container fluid v-resize="onResize" style="padding: 55px 35px 196px 35px;">
        <v-card class="card-container" style="padding: 14px;  border-radius: 10px !important; background-color: #F1F1F1;">
            <v-row no-gutters class="standard-row header-container" align="center">
                <iframe style="width:100%; height:641px; border: 0px;"
                    src="https://app.powerbi.com/view?r=eyJrIjoiNzY1ZDM0MTEtZDY4Ny00NGUwLWE4YjgtM2Q3NGQ4YTJmNDE1IiwidCI6ImI3NmEyM2QzLThjZGYtNDNjMC1hNTNiLTYwYmNkMjM3OTg5NSIsImMiOjEwfQ%3D%3D">
                </iframe>
            </v-row>
        </v-card>
    </v-container>
</template>
<script>
import { EventBus } from "../EventBus";
export default {
    data: () => ({
        windowSize: { x: 0, y: 0 },
    }),
    mounted() {
        this.onResize()
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
    }
};
</script>
<style>
</style>
